<h1 mat-dialog-title>
    <span translate>global.actions.ajouter</span>
    <span [mat-dialog-close]="true"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm">
        <div class="row">
            <custom-input ngDefaultControl
                          id="zu"
                          name="zu"
                          [(ngModel)]="zu"
                          [selectOptions]="listeZu"
                          [valeurIdTampon]="'objetTampon'"
                          customType="objectselect"
                          optionDisplay="libelle"
                          optionValue="idZU"
                          lCol="4"
                          rCol="7"
                          [isSelectAvecVide]="false"
                          [isSelectAvecInput]="false"
                          [hasForcedError]="hasForcedError"
                          libelle="admin.frais.prestations.detail.zu.zonesUtilisateur.zu"
                          (onChange)="onZuChange()"
                          [required]="true"
                          [disabled]="!listeZu?.length">
            </custom-input>
        </div>
        <div class="row">
            <custom-input ngDefaultControl
                          id="obligatoire"
                          name="obligatoire"
                          [ngModel]="zu.lienZuPrestObligatoire"
                          [(customModel)]="zu.lienZuPrestObligatoire"
                          customType="checkbox"
                          lCol="4"
                          rCol="7"
                          libelle="admin.frais.prestations.detail.zu.zonesUtilisateur.obligatoire"
                          postLibelle="admin.frais.prestations.detail.zu.zonesUtilisateur.obligatoire"
                          [postTooltip]="zu.obligatoire ? ('admin.frais.prestations.detail.zu.zonesUtilisateur.obligatoireZu' | translate) : null"
                          [disabled]="!listeZu?.length || zu.obligatoire">
            </custom-input>
        </div>

        <div class="d-flex flex-row-reverse">
            <button mat-flat-button color="primary" class="ms-2"
                    (click)="add()"
                    [disabled]="form.invalid || !listeZu?.length || hasForcedError">
                <span [translate]="'global.actions.enregistrer'"></span>
            </button>
            <button mat-stroked-button color="primary"
                    (click)="matDialogRef.close(null)">
                <span [translate]="'global.actions.annuler'"></span>
            </button>
        </div>
    </form>
</div>
